module.exports = __webpack_public_path__ + "img/banner202510.0614f087.png";